import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import UIProgress from 'UIComponents/progress/UIProgress';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
const LimitCardProgressBar = ({
  limit
}) => {
  const {
    usage,
    limit: currentLimit,
    limitName
  } = limit;

  //fix for portals with older versions of the hubspot-free parcel
  const correctedCurrentLimit = currentLimit === null ? 2500 : currentLimit;
  const percentageOfLimitUsed = usage / correctedCurrentLimit * 100;
  const progressBarColorProp = percentageOfLimitUsed === 100 ? 'danger' : percentageOfLimitUsed > 33 ? 'warning' : 'success';
  const remainingUsage = correctedCurrentLimit - usage;
  const progressBarLabelI18nKey = remainingUsage ? `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.remainingUsage` : `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.limitReached`;
  return /*#__PURE__*/_jsx("div", {
    className: "width-100",
    children: /*#__PURE__*/_jsx(UIProgress
    //When the "danger" (red) color is used, the value prop behaves as the starting point where the bar gets colored,
    //so to color the entire bar, the value has to be 0.
    , {
      value: percentageOfLimitUsed === 100 ? 0 : percentageOfLimitUsed,
      use: progressBarColorProp,
      descriptiveLabel: /*#__PURE__*/_jsx("span", {
        style: {
          fontSize: '12px',
          fontWeight: WEB_FONT_MEDIUM_WEIGHT
        },
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: progressBarLabelI18nKey,
          options: {
            remainingUsage
          }
        })
      }),
      valueLabel: /*#__PURE__*/_jsx(Small, {
        weight: "regular",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.progressBarCount`,
          options: {
            usage,
            limit: correctedCurrentLimit
          }
        })
      })
    })
  });
};
export default LimitCardProgressBar;